import { BrowserRouter } from "react-router-dom";
import AppRouter from "@/router/AppRouter";
import "../styles/globals.css";
import "../styles/theme.css";
import "../styles/design-system.css";
import { QueryProvider } from "@/modules/auth/authproviders/QueryProvider";
import { AuthProvider } from "@/modules/auth/authproviders/AuthProvider";
import { CookieConsentProvider } from "@/shared/cookies/CookieConsentProvider";
import SeoManager from "@/shared/seo/SeoManager";

const App = () => (
  <QueryProvider>
    <AuthProvider>
      <BrowserRouter>
        <CookieConsentProvider>
          <SeoManager />
          <AppRouter />
        </CookieConsentProvider>
      </BrowserRouter>
    </AuthProvider>
  </QueryProvider>
);

export default App;
